import { render, staticRenderFns } from "./SatelliteGroups.vue?vue&type=template&id=55bbc32c&scoped=true"
import script from "./SatelliteGroups.vue?vue&type=script&lang=js"
export * from "./SatelliteGroups.vue?vue&type=script&lang=js"
import style0 from "./SatelliteGroups.vue?vue&type=style&index=0&id=55bbc32c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bbc32c",
  null
  
)

export default component.exports